module.exports = __webpack_public_path__ + "img/b2.fd1af778.png";